import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Tabs } from '~/shared/ui'
import { OrdersItemsTable } from '~/features/delivery/shipping-order-by-id/ui/OrderItemsTable'
import { PrintedForm } from '~/features/delivery/shipping-order-by-id/ui/PrintedForm'
import type { KitRelabelUnit } from '~/shared/api/services/delivery/types'

interface DeliveryTabsProps {
  onLastItemChecked?: () => void
  canScanLastItem?: boolean
  capsLockEnabled?: boolean
  kitRelabelRequired?: boolean
  kitRelabelUnit?: KitRelabelUnit | null
  onKitComponentScanned?: (productVariationId: string) => boolean
  onKitNewSkuScanned?: (barcode: string) => Promise<boolean>
}

export const DeliveryTabs = observer(
  ({
    onLastItemChecked,
    canScanLastItem = true,
    capsLockEnabled = false,
    kitRelabelRequired = false,
    kitRelabelUnit = null,
    onKitComponentScanned,
    onKitNewSkuScanned,
  }: DeliveryTabsProps) => {
    const { t } = useTranslation()

    const tabHeaderDelivery = useMemo(() => {
      return [
        { id: 1, label: t('productsInTheOrder') },
        { id: 2, label: t('printedForm') },
      ]
    }, [t])

    const tabContenDelivery = useMemo(() => {
      return [
        {
          id: 1,
          element: (
            <OrdersItemsTable
              canScanLastItem={canScanLastItem}
              onLastItemChecked={onLastItemChecked}
              capsLockEnabled={capsLockEnabled}
              kitRelabelRequired={kitRelabelRequired}
              kitRelabelUnit={kitRelabelUnit}
              onKitComponentScanned={onKitComponentScanned}
              onKitNewSkuScanned={onKitNewSkuScanned}
            />
          ),
        },
        { id: 2, element: <PrintedForm capsLockEnabled={capsLockEnabled} /> },
      ]
    }, [
      canScanLastItem,
      onLastItemChecked,
      capsLockEnabled,
      kitRelabelRequired,
      kitRelabelUnit,
      onKitComponentScanned,
      onKitNewSkuScanned,
    ])

    return (
      <div className="mt-10">
        <Tabs
          tabsType="contained"
          tabsHeader={tabHeaderDelivery}
          tabsContent={tabContenDelivery}
        />
      </div>
    )
  },
)
